// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"9c999344","453":"06841f54"}[chunkId] + ".chunk.js";
};